<template>
    <el-dialog  title="协议信息" :visible.sync="showBlock" :destroy-on-close="true" width="600px" :close-on-click-modal="false">
        <el-form :model="formDate" ref="formDate"  label-width="70px" class="demo-ruleForm">
            <el-form-item  label="协议名称" prop="name" >
                <el-input v-model="formDate.name" :size="this.$store.state.popSize" :readonly="true" maxlength="30" placeholder="请输入协议名称" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item  label="所属公司" prop="company" >
                <el-input v-model="formDate.company" :size="this.$store.state.popSize" :readonly="true" maxlength="30" placeholder="请输入协议所属的公司" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item  label="使用工厂" prop="factoryIds">
                <div class="warp-gc">
                    <span v-for="(item,index) in protocolFactories" :key="index">{{item.factoryName}}</span>
                </div>
            </el-form-item>
            <div class="common-flex">
                <div class="verTitle">协议版本</div>
                <div class="warp-version">
                    <div class="version" :class='[item.mark ? "error":""]' v-for="(item,index) in protocolVersions" :key="index">
                        <el-input style="width:145px" v-model="item.name" :readonly="true"  maxlength="10" placeholder="请输入协议版本" autocomplete="off"/>
                    </div>     
                </div>
            </div>
            <el-form-item  label="使用指南" prop="descr" v-if="formDate.resouces.length>3">
                <div class="guide">{{formDate.resouces}} <span @click="lookBtn(formDate.resouces,1)" class="look">查看</span> <a class="down" id="links" download @click="lookBtn(formDate.resouces,2)">下载</a> </div>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
  import {url,api} from '@/utils/config'
  import {getFun} from '@/utils/httpFun'
  export default{
     components:{
     
     },
     data(){
       return{

            optionsList:[],
            listArray:[],              //协议版本  
            protocolVersions:[],
            protocolFactories:[],  
            formDate: {
                id:"",                 //对应的ID
                name:"",               //协议名称
                company:"",            //所属公司 
                resouces:[] 
            },
            showBlock: false
       }
     },
    
     created(){
       
     },
     methods:{
        //开启弹窗
        showBlockMe(ev){
            
            this.formDate={
                id:ev.id,
                name:ev.name,
                company:ev.company,
                resouces:ev.resouces
            }  
            this.protocolFactories = ev.protocolFactories
            this.protocolVersions = ev.protocolVersions 
            this.showBlock = true 
        },

        //查看
        lookBtn(ev,mark){
            let parms = {
               bucketName:api.bucketName,
               objectName:ev
            }
            getFun(url.SHOWIMG,parms,res=>{
                if(mark==1){
                    window.open(res.data,'top')
                }else{
                    document.getElementById('links').href = res.data
                }
            }) 
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }

   .name{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #4D5C72;
        letter-spacing: 0;
   }
   .warp-version{
     display: flex;
     flex-wrap: wrap;
     width:490px;
     position: relative;
     z-index: 10;

   }
   .verTitle{
     margin-right: 14px;
     position: relative;
     top: 8px;
   }
   .version{
     margin-bottom: 24px;
     position: relative;
     width: 145px;
     margin-right: 15px;
    
     }
     .version.error{
        ::v-deep .el-input__inner{
          border: 1px solid #F56C6C
      }
     .tishi{
            color: #F56C6C;
            font-size: 12px;
            line-height: 1;
            padding-top: 4px;
            position: absolute;
            top: 100%;
            left: 0; 
    }   
   }
   .el-icon-circle-plus-outline{
      font-size: 22px;
      margin-left: 5px;
   }
   .el-icon-circle-plus-outline,.el-icon-remove-outline{
      font-size: 18px;
      margin-left:6px;
      color: #ADADAD;
      position: absolute;
      top:11px;
      right:10px;

   }
   .el-uploadPdf{
      position: relative;
      ::v-deep .el-upload-dragger{
          width: 490px;
          height: 150px;
      }
      ::v-deep .el-upload-dragger .el-icon-upload{
          margin: 21px 0 16px;
      }
      .prompt{
        position: absolute;
        bottom:-20px;
        color: #606266;
        font-size: 12px;
       
      }
   }
   .warp-gc{
     width: 100%;
     border: 1px solid #DCDFE6;
     padding: 10px;
     box-sizing: border-box;
     border-radius:4px;
     display: flex;
     flex-wrap: wrap;
     max-height: 100px;
     span{
        margin-right: 5px;
        border: 1px solid rgba(23,155,245,0.2);
        font-size: 12px;
        padding:2px 5px;
        display: block;
        height: 22px;
        line-height: 22px;
        margin-bottom:5px;
        border-radius: 4px;
     }
     
   }
   .guide{
      font-size: 14px;
      .look{
         color: #409EFF;
         cursor: pointer;
         margin-left: 10px;
         margin-right: 10px;
      }
      .down{
         color: #606266;
         cursor: pointer;
         text-decoration: none;
      }
   }

   .warp-btn{
    opacity: 0;
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   
</style>